import { useMemo } from "react";
import DrinksMenuPanel from "./DrinksMenuPanel";
import { getDrinksBoardPanels } from "../../../data/drinksMenuLayout";

function DrinksMenuBoard({ lang, onOpen, vatNote }) {
  const panels = useMemo(() => getDrinksBoardPanels(lang), [lang]);

  return (
    <div className="drinks-menu-board">
      <div className="drinks-menu-board-grid" role="list">
        {panels.map((panel) => (
          <DrinksMenuPanel
            key={panel.id}
            panel={panel}
            lang={lang}
            onOpen={onOpen}
          />
        ))}
      </div>
      {vatNote ? <p className="drinks-menu-vat">{vatNote}</p> : null}
    </div>
  );
}

export default DrinksMenuBoard;
